<!-- 积分设置 -->
<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="small"
        @click="gotoAdd()"
        >添加规则</el-button
      >
    </div>
    <div>
      <el-table :data="tableData" border>
        <el-table-column label="规则类型" prop="type">
          <template slot-scope="scope">
            <div
              v-text="
                scope.row.type == 1
                  ? '消费送积分'
                  : scope.row.type == 2
                  ? '充值送积分'
                  : '积分抵扣'
              "
            ></div>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="open">
          <template slot-scope="scope">
            <div v-text="scope.row.open == 1 ? '开启' : '关闭'"></div>
          </template>
        </el-table-column>
        <el-table-column label="时间类型" prop="time_status">
          <template slot-scope="scope">
            <div
              v-text="scope.row.time_status == 0 ? '固定时间段' : '按周期时间'"
            ></div>
          </template>
        </el-table-column>
        <el-table-column label="适用油品" prop="show_goods">
          <template slot-scope="scope">
            {{ scope.row.show_goods.join(",") }}
          </template>
        </el-table-column>
        <el-table-column label="适用会员级别" prop="show_levels">
          <template slot-scope="scope">
            {{ scope.row.show_levels.join(",") }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row.id)"
              >修改</el-button
            >
            <el-button type="text" @click="delItem(scope.row.id)"
              >删除</el-button
            >
            <el-button
              type="text"
              v-text="scope.row.open == 0 ? '开启' : '关闭'"
              @click="isopen(scope.row.id, scope.row.open == 0 ? 1 : 0)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { goodsList, levelGroupSelect } from "@/api/vip";
import { point_config_del, point_config_disable, point_config_list } from "@/api/pointSetting";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["app_id"])
  },
  data() {
    return {
      tableData: [],
      vipList: [],
      shopsList: [],
    };
  },
  mounted() {
    this.get_levelGroupSelect();
    this.get_goods();
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    gotoAdd() {
      this.$router.push("pointSetting_set");
    },
    async getList() {
      const res = await point_config_list({ app_id: this.app_id });
      if (res.code == 200) {
        this.tableData = res.data;
        this.tableData.forEach(item => {
          item.show_goods = [];
          item.show_levels = [];
          item.goods.forEach(e => {
            item.show_goods.push(e.name);
          });
          item.user_levels.forEach(e => {
            item.show_levels.push(e.name);
          });
        });
      }
    },
    async get_goods() {
      let data = {
        app_id: this.app_id,
        store_id: 0
      };
      const res = await goodsList(data);
      if (res.code == 200) {
        this.shopsList = res.data;
      }
    },
    async get_levelGroupSelect() {
      const res = await levelGroupSelect({ app_id: this.app_id });
      if (res.code == 200) {
        this.vipList = res.data;
      }
    },
    editItem(id) {
      this.$router.push({
        path: "pointSetting_set",
        query: {
          id: id
        }
      });
    },
    async isopen(id, open) {
      const res = await point_config_disable({
        app_id: this.app_id,
        id: id,
        open: open
      });
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getList();
      } else {
        this.$message.error(res.msg);
      }
    },
    async delItem(id) {
      const confirmRes = await this.$confirm(
        '此操作将永久删除该数据, 是否继续?',
        '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => console.log(err))
      if (confirmRes == 'confirm') {
        const res = await point_config_del({ app_id: this.app_id, id: id });
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.getList();
        } else {
          return this.$message.error(res.msg);
        }
      }else {
        return this.$message.info('已经取消删除')
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
